module.exports = __webpack_public_path__ + "img/src/components/ContactForm/mailblack.svg?8b4e6bd1";